import { Alert, Box, Center, Loader } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthProvider';
import { usePasswordState } from '../../modules/auth/password/usePasswordState';
import { expiryNotice } from '../../modules/auth/password/passwordState';

const PASSWORD_PATH = '/password';

export default function ProtectedLayout() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  // Состояние пароля перечитывается при смене адреса: смену мог назначить
  // администратор, пока человек работал.
  const passwordState = usePasswordState(isAuthenticated);

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="xl" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // Просроченный пароль: работа закрыта, остаётся только смена. Запрет держит
  // бэкенд (403 с признаком password_expired), здесь — чтобы человек не
  // смотрел на экраны с ошибками вместо понятного требования.
  const expired = passwordState?.expired && passwordState.applies;
  if (expired && location.pathname !== PASSWORD_PATH) {
    return <Navigate to={PASSWORD_PATH} replace />;
  }

  const notice = expiryNotice(passwordState);
  const showNotice = notice && location.pathname !== PASSWORD_PATH;

  return (
    <>
      {showNotice && (
        <Box px="md" pt="xs">
          <Alert color={notice.color} icon={<IconAlertTriangle size={18} />}>
            {notice.text}{' '}
            <Link to={PASSWORD_PATH}>Сменить пароль</Link>
          </Alert>
        </Box>
      )}
      <Outlet />
    </>
  );
}
